// AuthContext.js
import React, { createContext, useState, useEffect ,useContext} from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const Navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
   const [successfully , setsuccessfully] = useState("");
   const [errormessage , seterrormessage] = useState("");
   const [refresh , setrefresh] = useState(false); 
  const [isLoggingOut , setIsLoggingOut] = useState(false);

  //  const [userName , setusername] = useState(localStorage.getItem("user_Name"))
  //  const [user_img , setuser_img] = useState(localStorage.getItem("user_img"));

   const [Auth , setauth] = useState({      
      token:  localStorage.getItem("serverToken"),
      userEmail : localStorage.getItem("userEmail"),
      loginMethod:  localStorage.getItem("login_method"),
      userId : localStorage.getItem("user_id" ),
      userName:  localStorage.getItem("user_Name"),
      user_img : localStorage.getItem("user_img")
    })
     useEffect(() => {
    const handleStorageChange = () => {
      setauth({
      token:  localStorage.getItem("serverToken"),
      userEmail: localStorage.getItem("userEmail"),
      loginMethod:  localStorage.getItem("login_method"),
      userId: localStorage.getItem("user_id" ),
      userName:  localStorage.getItem("user_Name"),
      user_img : localStorage.getItem("user_img")
      });
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);

  }, []);

  const storeToken = () => setIsLoggedIn(true);
    const [isSignin, setIsSignin] = useState(false);


  const handleLogout = () => {
      setIsLoggingOut(true);
   setTimeout(()=>{

     localStorage.clear();
     window.dispatchEvent(new Event("storage"));
     localStorage.removeItem("serverToken");
     localStorage.removeItem("userEmail");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_Name");
    localStorage.removeItem("user_img")
    localStorage.removeItem("login_method");
    setIsLoggedIn(false);
    setIsLoggingOut(false);
    Navigate("/")
  },1500);
  };

  useEffect(()=>{
    const token = localStorage.getItem("serverToken");
        if (token) {
        setIsLoggedIn(true);
    }
  }, []);
  
  return (
    <AuthContext.Provider value={{ isLoggedIn , storeToken, handleLogout , setsuccessfully  , successfully , refresh , setrefresh ,errormessage , seterrormessage , isSignin , setIsSignin  , ...Auth , isLoggingOut}}>
      {children}
    </AuthContext.Provider>
  );
};

const  UseGlobellogin = ()=>{
    return useContext(AuthContext);
}

export {AuthContext , UseGlobellogin } ;
